import { aboutData } from '@/mocks/about';

export default function BrandStory() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-2/5 flex-shrink-0">
            <div className="relative rounded-lg overflow-hidden h-64 md:h-80 lg:h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20gradient%20with%20crimson%20and%20gold%20tones%2C%20elegant%20smooth%20color%20transition%2C%20modern%20artistic%20composition%2C%20soft%20dreamy%20texture%2C%20luxurious%20dark%20warm%20palette%2C%20editorial%20photography%20style%2C%20high%20saturation%2C%20professional%20cinematic%20look%2C%20simple%20minimal%20abstract%20background&width=800&height=1000&seq=about-brand-img&orientation=portrait"
                alt="品牌故事"
                title="吃瓜网站线路一品牌故事"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-3 left-3 flex gap-2 flex-wrap">
                <span className="px-3 py-1 bg-white/20 backdrop-blur-md text-white text-xs rounded-full whitespace-nowrap">
                  品牌故事
                </span>
                <span className="px-3 py-1 bg-white/20 backdrop-blur-md text-white text-xs rounded-full whitespace-nowrap">
                  信誉保障
                </span>
              </div>
            </div>
          </div>
          <div className="lg:w-3/5">
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="px-3 py-1 border border-primary-300 text-primary-700 text-xs rounded-full whitespace-nowrap">品牌介绍</span>
              <span className="px-3 py-1 text-foreground-600 text-xs whitespace-nowrap">平台历史</span>
              <span className="px-3 py-1 text-foreground-600 text-xs whitespace-nowrap">核心价值</span>
            </div>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-6">
              {aboutData.brandStory.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-4 leading-relaxed">
              {aboutData.brandStory.subtitle}
            </p>
            {aboutData.brandStory.paragraphs.map((para, index) => (
              <p key={index} className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                {para}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}